module.exports = __webpack_public_path__ + "media/src/img/favicon16-9e728a2c6302bf3b10c17cc2bebd25cc.svg";